import React, { useEffect, useState } from "react";

type IntroProps = {
  language: "en" | "vn";
  setLanguage: (lang: "en" | "vn") => void;
  onStart: () => void;
};



const IntroScreen = ({ language, setLanguage, onStart }: IntroProps) => {
 
  const content = {
    en: {
      title: "Test your knowledge of facilitation methods and techniques!",
      intro:
        "What we call facilitation is to guide a group towards their goal, without bringing any content. Just by facilitating the process. Sounds easy? Let's see!",
      how:
        'You want to see where you stand in the levels of facilitation? Click on "proceed" below and we will put you in a real life situation. Every time, you can select the answer that you feel would work the best in that situation. At the end you will see your score and a recommendation.',
      proceed: "Proceed",
      langToggle: "English / Tiếng Việt",
      loading: "Loading visuals..."
    },
    vn: {
      title: "Kiểm tra kiến ​​thức của bạn về các phương pháp và kỹ thuật hỗ trợ!",
      intro:
        "Những gì chúng tôi gọi là hỗ trợ là hướng dẫn một nhóm đến mục tiêu của họ, mà không mang lại bất kỳ nội dung nào. Chỉ bằng cách hỗ trợ quá trình. Nghe có vẻ dễ phải không? Chúng ta hãy cùng xem!",
      how:
        'Bạn muốn biết mình đang ở đâu trong các cấp độ hỗ trợ? Nhấp vào "tiến hành" bên dưới và chúng tôi sẽ đưa bạn vào một tình huống thực tế. Mỗi lần, bạn có thể chọn câu trả lời mà bạn cảm thấy sẽ hiệu quả nhất trong tình huống đó. Cuối cùng, bạn sẽ thấy điểm số của mình và một khuyến nghị.',
      proceed: "Tiến hành",
      langToggle: "English / Tiếng Việt",
      loading: "Đang tải hình ảnh..."
    }
  };

  const t = content[language];

   return (
    <>
     <div className="sponsor-bar">
  <span>Made possible by:</span>
  <img src="/assets/NNT.jpg" alt="Logo No-Nonsense Training" style={{ height: "90px" }} />
  <img src="/assets/BWA.png" alt="Logo Betterworks Asia" />
</div>

  <div className="intro-container">
    <div className="intro-content">
      <h1>{t.title}</h1>
      <p>{t.intro}</p>
      <p>{t.how}</p>

      <div className="language-toggle">
        <button
          onClick={() => setLanguage("en")}
          className={language === "en" ? "active" : ""}
        >
          English
        </button>
        <button
          onClick={() => setLanguage("vn")}
          className={language === "vn" ? "active" : ""}
        >
          Tiếng Việt
        </button>
      </div>

      <button className="intro-button" onClick={onStart}>
        {t.proceed}
      </button>
    </div>
  </div>
    </>
);
};

export default IntroScreen;
